import { formatCurrency } from 'utils/CurrencyUtils';
import { useGetOrderDetailById } from 'shared/hooks';

import type { OrderId, ProductId } from 'shared/domain';

export function useSubstitutionFlowProductHOC(props: Props) {
  const { orderId, orderProductId } = props;

  const { data: order } = useGetOrderDetailById(orderId);

  const sfState = order.substitutionFlowState;

  const stockoutItem = sfState?.products?.find(
    p => p.orderProductId === orderProductId,
  );

  const replacementItem = stockoutItem?.replacements?.[0];

  const hasReplacement = sfState?.status === 'accepted' && !!replacementItem;

  const price =
    order.products.filter(p => p.orderProductId === orderProductId)[0]?.price
      .totalReal ?? 0;

  return {
    hasReplacement,
    stockoutItem,
    replacementItem,
    formatedPrice: formatCurrency(price),
  };
}

interface Props {
  orderId: OrderId;
  orderProductId: ProductId;
}
